
import './Sprint.css';
// import CycleCalendar from './CycleCalendar.js'
// import CycleHabits from './CycleHabits.js'
// import CycleMeals from './CycleMeals'
// import CycleMilestones from './CycleMilestones'
// import CycleSchedule from './CycleSchedule'
import React from "react";

function Sprint(props) {

    return (
        <div className="">
            <p className="sprintHeaderText"> SPRINT VIEW COMING SOON</p>
            <div className="sprintGrid"></div>
            {/* <div className="sprintRow">
                <CycleMeals userProfile={props.userProfile}/>
                <CycleMilestones userProfile={props.userProfile}/>
            </div>
            <div className="sprintRow">
                <CycleCalendar userProfile={props.userProfile}/>
                <CycleHabits userProfile={props.userProfile}/>
            </div>
            <div className="sprintRow">
                <CycleSchedule userProfile={props.userProfile}/>
            </div> */}
        </div>
    )
}

export default Sprint;